import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import CitationsView from "scripts/views/citationsView";
import templateContentDetailsBookPageDetailsSubPage from "templates/contentDetailsBookPageDetailsSubPage.hbs";
import templateCategoryLink from "templates/categoryLink.hbs";

class ContentDetailsBookPageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  constructor(options) {
    super(options);

    this.citationsView = this.addSubView(
      new CitationsView({
        mediaId: this.model.get("id"),
      }),
    );
  }

  get template() {
    return templateContentDetailsBookPageDetailsSubPage;
  }

  get categoryTemplate() {
    return templateCategoryLink;
  }

  render() {
    super.render();

    if (this.model.has("bisacCategories")) {
      this.addCategories(this.model.get("bisacCategories"));
    }

    this.citationsView
      .attachTo($("#bb-content-details-citation-region"))
      .fetch()
      .then(() => this.citationsView.render());

    return this;
  }

  addCategories(categories) {
    const $categories = $(
      "#bb-content-details-book-page-details-sub-page-category-region",
    );

    const commaSeparatedCategoryLinks = categories
      .map(category => {
        return this.categoryTemplate(category);
      })
      .join(",&nbsp;");

    $categories.html(commaSeparatedCategoryLinks);
  }
}

export default ContentDetailsBookPageDetailsSubPageView;
